import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Box, Container, Typography, Button, TextField, Breadcrumbs } from '@material-ui/core';
import { useParams } from 'react-router-dom';
import { useGet, usePost, usePut, useDelete } from '../../API/request';
import { useConfirm } from '../../components/Confirm/index';
import {Link as RouterLink, useNavigate} from 'react-router-dom';
import ChevronLeft from '@material-ui/icons/ChevronLeft';

const SeoUrlSettings = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const confirm = useConfirm();
  const getU = useGet();
  const postU = usePost();
  const putU = usePut();
  const deleteU = useDelete();

  const [seoUrl, setSeoUrl] = useState({});
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [schema, setSchema] = useState('');

  useEffect(() => {
    getSeoUrl();
  }, []);

  const getSeoUrl = () => {
    getU(`seo_url/${id}`)
      .then((resp) => {
        if (resp.status === 'success') {
          setSeoUrl(resp.data);
          console.log(resp.data)
          setName(resp.data.name || '');
          setDescription(resp.data.description || '');
          setSchema(resp.data.schema || '');
        }
      })
      .catch((err) => {
        console.log(err.response);
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const newData = {
      ...seoUrl,
      name,
      description,
      schema,
    };

    if (id) {
      putU(`seo_url/${id}`, newDataMock)
        .then((resp) => {
          if (resp.status === 'success') {
            console.log(resp);
          } else {
            throw new Error(resp.message);
          }
        })
        .catch((err) => {
          console.log(err.message);
        });
    } else {
      postU('seo_url', newData)
        .then((resp) => {
          if (resp.status === 'success') {
            console.log(resp.data.data);
          }
        })
        .catch((err) => {
          console.log(err.response);
        });
    }
  };

  const handleDelete = () => {
    confirm({
      title: 'Удаление',
      content: 'Вы уверены, что хотите удалить настройки SEO для этого URL?',
      onConfirm: () => {
        deleteU(`seo/url/${id}`)
          .then((resp) => {
            if (resp.status === 'success') {
            }
          })
          .catch((err) => {
            console.log(err.response);
          });
      },
    });
  };

  return (
    <>
      <Helmet>
        <title>SEO URL Настройки</title>
      </Helmet>
      <Box sx={{pt: 2}}>
      <Container maxWidth={false}>
      <Button startIcon={<ChevronLeft/>} onClick={() => navigate(-1)}>
            Назад
          </Button>
          <Breadcrumbs aria-label="breadcrumb" style={{ fontSize: 14 }}>
            <RouterLink underline="hover" color="inherit" to="/app/seo">
                SEO
            </RouterLink>
                <p>Редактировать SEO</p>
                </Breadcrumbs>
        </Container>
        </Box>
      <Container>
        <Box my={2}>
          <Typography variant="h4" component="h1" gutterBottom>
            {id ? 'Отредактировать SEO URL настройки' : 'Добавить SEO URL настройки'}
          </Typography>
          <form onSubmit={handleSubmit}>
            <Box mb={2}>
              <TextField
                fullWidth
                label="Name"
                variant="outlined"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </Box>
            <Box mb={2}>
              <TextField
                fullWidth
                label="Description"
                variant="outlined"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </Box>
            <Box mb={2}>
              <TextField
                fullWidth
                label="Schema"
                variant="outlined"
                value={schema}
                onChange={(e) => setSchema(e.target.value)}
                multiline
                rows={6}
              />
            </Box>
            <Button type="submit" variant="contained" color="primary" style={{ marginRight: '10px' }}>
  Сохранить
</Button>
            {id && (
              <Button
                variant="contained"
                color="error"
                onClick={handleDelete}
              >
                Удалить
              </Button>
            )}
          </form>
        </Box>
      </Container>
    </>
  );
};

export default SeoUrlSettings;
